export class OOOrderTypeField {
	orderTypeKey: number;
	key: string;
	displayName: string;
	description?: string;
	sortOrder?: number;
	required: boolean;
	value?: string;

	public constructor(init?: Partial<OOOrderTypeField>) {
		Object.assign(this, init);
	}
}
